
<div class="Vert-15"></div>
<div class="container">

    <div class="row">
        <div class="col-12">
            <h3>Apply Now!</h3>
            <div>Please enter your information to start the loan application.</div>
            <div class="Vert-20"></div>
        </div>
    </div>

    <form [formGroup]="_form" *ngIf="isReady">

        <div class="row">

            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                <mat-label>First Name</mat-label>
                <input type="text" matInput formControlName="firstName" maxlength="100" placeholder="First">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                <mat-label>Last Name</mat-label>
                <input type="text" matInput formControlName="lastName" maxlength="100" placeholder="Last">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                <mat-label>Email</mat-label>
                <input type="text" matInput formControlName="email" maxlength="50" placeholder="Enter email here">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                <mat-label>Phone</mat-label>
                <input type="text" matInput formControlName="phone" maxlength="50" placeholder="000-000-0000">
            </mat-form-field>

            <!--<mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                <mat-label>Agent</mat-label>
                <input type="text" matInput formControlName="agent">
            </mat-form-field>-->

        </div>
    </form>


    <div class="row">
        <div class="col-12" align="end">

            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()" [disabled]="!_form.valid"> Submit </button>
            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end" style="margin-right:10px;"> Cancel </button>
        </div>
    </div>

</div>
<div class="Vert-15"></div>

<lgv-loading-indicator *ngIf="!isReady"></lgv-loading-indicator>

